import React, {Fragment} from 'react';
import {I18nCalendar} from 'js/Core/constants';
import { lang } from 'js/Core/lang';
import {getIndexDay, customAddDate, isSameDate, comparingDate, customFormatMonth, customFormatDate} from 'js/Core/date';

class Calendar extends React.PureComponent {
    constructor(props){
        super(props);
        this.state = {
            checkHaveTwoMonth : false
        }
    }    
    listDayName(){
        return Object.keys(I18nCalendar.dayName).map((k) => I18nCalendar.dayName[k])
    }
    renderDayName(list){
        let listDayName = this.listDayName();
        let result = [];
        for(let i in list){
            let indexDay = getIndexDay(list[i]);
            result.push(listDayName[indexDay]);
        }
        return result;
    }
    checkHaveTwoMonth(date){        
        let endOfWeekNew = customAddDate(date, 6),
            montOfFirstWeek = new Date(date).getMonth(),
            monthOfEndWeek = new Date(endOfWeekNew).getMonth();

        return montOfFirstWeek !== monthOfEndWeek ? true : false
    }
    countDateOtherMonth(date){
        let endOfWeek = customAddDate(date, 6);
        let dateClone = new Date(date);
        let count = 0;
        while(isSameDate(dateClone, endOfWeek, true)){
            if(dateClone.getMonth() !== new Date(date).getMonth()){
                count++;
            }
            dateClone = customAddDate(dateClone, 1);
        }
        return count;
    }
    checkCanNavigation(listDateOfWeek, bol = false){
        let isValid = true;
        if(bol){ // next
            listDateOfWeek.forEach(e => {
                if(comparingDate(this.props.toDateShop, e)){
                    isValid = false;
                    return;
                }
            })
        }else{ // prev
            let {firstDateWorking} = this.props,
                startDate = firstDateWorking;
            if(comparingDate(firstDateWorking, new Date())){
                startDate = new Date();
            }
            listDateOfWeek.forEach(e => {
                if(isSameDate(e,startDate, true)){
                    isValid = false;
                    return;
                }
            })
        }
        return isValid;
    }
    handleNavigation(listDateOfWeek, bol = false){
        if(this.checkCanNavigation(listDateOfWeek, bol)){
            this.props.navigateAction(bol);
        }
    }
    renderHeaderHtml(date){
        let count =  this.countDateOtherMonth(date); 
        let currentWidth = (100 / 7) * (7 - count),
            nearWith = (100 / 7) * count,
            dateOfEndWeek = customAddDate(date, 6);
        return (
            this.checkHaveTwoMonth(date) ?
            <Fragment>
                <span className="month-current" style={{width: currentWidth < 100 ? currentWidth+'%' : ''}}>{customFormatMonth(date)}</span>
                <span className="month-near" style={{width: nearWith > 0 ? nearWith+'%' : ''}}>{customFormatMonth(dateOfEndWeek)}</span>
            </Fragment> :
            <span className="month-current">
                {customFormatMonth(date)}
            </span>
        )        
    }
    listDateOfWeekFunc(date){
        // with this theme , first day of week is current day
        let startOfWeek = new Date(date),
            endOfWeek = customAddDate(date, 6),
            days = [],
            day = startOfWeek;
        while (isSameDate(day, endOfWeek, true)) {
            days.push(customFormatDate(day));
            day = customAddDate(day, 1);
        }
        return days;
    }
    render() {
        const {selectedCalendar} = this.props;
        let listDateOfWeek = this.listDateOfWeekFunc(selectedCalendar);
        let arr = this.renderDayName(listDateOfWeek);
        return (
            <div id="timeline-header-container" className="timeline-header clearfix">
                <div className={`timeline-action timeline-prev${!this.checkCanNavigation(listDateOfWeek) ? ' disabled': ''}`}>
                    <span onClick={e => this.handleNavigation(listDateOfWeek)}>{lang.label.label_prev_calendar}</span>
                </div>
                <div className="timeline-header-date">
                    <div className={`date-top${this.checkHaveTwoMonth(selectedCalendar) ? ' date-top-two-month' : ''}`}>
                        {
                            this.renderHeaderHtml(selectedCalendar)
                        }
                    </div>
                    <div className="date-list clearfix">
                        {
                            listDateOfWeek && Object.keys(listDateOfWeek).map(e => 
                                <div key={e} className="item"><span>{new Date(listDateOfWeek[e]).getDate()}<br />({arr[e]})</span></div>
                            )
                        }
                    </div>
                </div>
                <div className={`timeline-action timeline-next${!this.checkCanNavigation(listDateOfWeek, true) ? ' disabled': ''}`}>
                    <span onClick={e => this.handleNavigation(listDateOfWeek, true)}>{lang.label.label_next_calendar}</span>
                </div>
            </div>
        );
    }
}

export default Calendar;
